import type { AppError } from '../core/error/appError';
import type { Availability } from '../core/model/availability';
import { hasSlots } from '../core/model/availability';

/**
 * Estado de la disponibilidad.
 *
 * "Cerrado ese día", "sin mesas" y "error" son tres situaciones distintas que llevan a tres
 * pantallas distintas; colapsarlas en "lista vacía" es lo que produce el mensaje genérico que
 * no dice al usuario qué hacer a continuación.
 */
export type AvailabilityState =
  | { readonly status: 'LOADING' }
  | { readonly status: 'AVAILABLE'; readonly availability: Availability }
  | { readonly status: 'NO_AVAILABILITY'; readonly availability: Availability }
  | { readonly status: 'CLOSED_THAT_DAY'; readonly availability: Availability }
  | { readonly status: 'ERROR'; readonly error: AppError };

export function availabilityStateOf(availability: Availability): AvailabilityState {
  if (availability.closedThatDay) return { status: 'CLOSED_THAT_DAY', availability };
  if (hasSlots(availability)) return { status: 'AVAILABLE', availability };
  return { status: 'NO_AVAILABILITY', availability };
}
